// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1256b4ed","898":"2a20d19a","905":"71b145b5"}[chunkId] + ".chunk.js";
};